(function() {
    'use strict';

    PsychSubjectiveTestingController.$inject = ['ipmConstants', '$uibModal', 'DateUtils', '$scope'];

    function PsychSubjectiveTestingController(constants, $uibModal, DateUtils, $scope) {
        var vm = this; //jshint ignore:line
        vm.addMidsessionClick = addMidsessionClick;
        vm.colLimit = 1000;
        vm.dateFormat = 'MM/dd/yyyy';
        vm.colMidsessionsSubjective = [];
        vm.colSubjectiveDateChange = colSubjectiveDateChange;
        vm.updateSelectAllCheckboxSubjective = updateSelectAllCheckboxSubjective;
        vm.isMidSessionReport = false;
        vm.isOtherReport = false;
        vm.isWeeklyReport = false;
        vm.deletingMidsessionColumnMessage = 'ipmApp.frpReport.pt.deletingMidsessionColumn';

        init();

        function init() {
            if (vm.subjectiveResponses) {
                // set the first subjectiveResponses colMidsessions
                setColMidsessionSubjective(vm.subjectiveResponses[0].midsessions);

            }
            vm.isMidSessionReport = vm.reportType === constants.FRP_REPORT_TYPE.MID_SESSION_REPORT;
            vm.isOtherReport = vm.reportType === constants.FRP_REPORT_TYPE.OTHER_REPORT;
            vm.isWeeklyReport = vm.reportType === constants.FRP_REPORT_TYPE.WEEKLY_REPORT;
            vm.isDischargeReport = vm.reportType === constants.FRP_REPORT_TYPE.DISCHARGE_REPORT;
            vm.isFirstReport = vm.reportType === constants.FRP_REPORT_TYPE.FIRST_REPORT;
            updateSelectAllCheckboxSubjective();
        }

        function setColMidsessionSubjective(midsessions) {
            if (midsessions) {
                _.forEach(midsessions, function (o) {
                    o.dated = DateUtils.convertDateTimeFromServer(o.dated);
                });
            }
            vm.colMidsessionsSubjective = midsessions;
        }

        function addNewMidsession(orderNumber, subjectiveResponseId) {
            return {id: null,
                frpReportPsychSubjectiveResponseId: subjectiveResponseId,
                dated: new Date(),
                testScore: "",
                testScoreRight: "",
                testScoreLeft: "",
                orderNumber: orderNumber,
                active: true,
                $isOpenCalendar: false};
        }

        function addMidsessionClick() {
            if (vm.subjectiveResponses && vm.colMidsessionsSubjective.length < vm.colLimit) {
                var orderNumber = _.isEmpty(vm.colMidsessionsSubjective) ? 0 : vm.colMidsessionsSubjective.length + 1;
                vm.subjectiveResponses.forEach(function (item) {
                        var midsession = addNewMidsession(orderNumber, item.id);
                        item.midsessions.push(midsession);
                });
                setColMidsessionSubjective(vm.subjectiveResponses[0].midsessions);
                emitOnchangeMidsessions(vm.subjectiveResponses);
            }
        }

        function emitOnchangeMidsessions(subjectiveResponses) {
            vm.onChangeMidsessions({subjectiveResponses: subjectiveResponses});
        }

        function colSubjectiveDateChange(colSub) {
            updateSubjectiveResponses(colSub);
        }

        function updateSubjectiveResponses(colSub) {
            // comment out because effect to isChanged(), updated on prepareMidssessionDated before submit data
            // vm.subjectiveResponses.forEach(function (item) {
            //     if (item.midsessions.length > 0) {
            //         item.midsessions.forEach(function (itemMidsessions) {
            //             if (itemMidsessions && colSub && itemMidsessions.orderNumber === colSub.orderNumber) {
            //                 itemMidsessions.dated = colSub.dated;
            //             }
            //         });
            //     }
            // });
        }

        vm.openCalendar = function (colSub) {
            colSub.$isOpenCalendar = !colSub.$isOpenCalendar;
        };

        vm.checkDisableMidsessions = function (rowMidIndex, midsessions) {
            // If there is more than 1 Midsession column then the most recent one should be editable
            if (midsessions && midsessions.length > 0) {
                if (midsessions.length === 1) {
                    return false;
                } else {
                    if (midsessions.length <= 1 || rowMidIndex !== midsessions.length - 1) {
                        return true;
                    }
                }
            }
        }

        vm.removeColMidsessions = function (colSub, $index) {
            vm.confirmDialogRemoveMidsessions(vm.deletingMidsessionColumnMessage, colSub, $index);
        }

        vm.removeColMidsessionsCallBack = function (colSub, $index) {
            if (vm.subjectiveResponses) {
                vm.subjectiveResponses.forEach(function (item) {
                    if (item && item.midsessions) {
                        if (item.midsessions[$index] && item.midsessions[$index].id) {
                            addToMidsessionsRemoved(item.midsessions[$index]);
                        }
                        item.midsessions.splice($index, 1);
                        // update orderNumber for midsessions
                        updateOrderNumberMidsession(item.midsessions);
                    }
                });
            }
        };

        function updateOrderNumberMidsession(midsessions) {
            if (midsessions) {
                midsessions.forEach(function (ms, index) {
                    ms.orderNumber = index;
                });
            }
        }

        function addToMidsessionsRemoved(midsessions) {
            if (midsessions) {
                midsessions.active = false;
                vm.midsessionsRemovedList.push(midsessions);
            }
        }

        vm.checkDisableColMidsessions = function ($index) {
            return vm.disableFields.testingColMidsession || vm.checkDisableMidsessions($index, vm.colMidsessionsSubjective)
                    || vm.disableFields.testingColMidsessionLeft || vm.disableFields.testingColMidsessionRight;
        };

        vm.checkRequiredDateMidsession = function ($index) {
            if (vm.checkDisableColMidsessions($index)) {
                return false;
            }
            var hasDataMidsession = _.some(vm.subjectiveResponses, function (item) {
                return item.midsessions && item.midsessions[$index] &&
                    (item.midsessions[$index].testScore || item.midsessions[$index].testScoreLeft || item.midsessions[$index].testScoreRight);
            });
            return hasDataMidsession;
        };

        vm.checkRequiredColMidsessions = function ($index) {
            // If the report type is "First Report", the "Initial Score" column will be required.
            return !vm.isFirstReport && !vm.isOtherReport
                && !vm.disableFields.testingColMidsession
                && !vm.disableFields.testingColMidsessionLeft
                && !vm.disableFields.testingColMidsessionRight
                && !vm.checkDisableMidsessions($index, vm.colMidsessionsSubjective)
                && checkRequiredMidByWeeklyReport();
        }

        vm.checkRequiredFieldScore = function() {
            return !vm.isOtherReport;
        }

        vm.checkRequiredFieldDischarge= function() {
            return vm.isDischargeReport;
        }

        vm.checkDisableRemoveColMidsessions = function () {
            return (!vm.isMidSessionReport && !vm.isOtherReport) || vm.disableFields.testingColMidsession || vm.disableFields.testingColMidsessionLeft  || vm.disableFields.testingColMidsessionRight;
        }

        function checkRequiredMidByWeeklyReport() {
            if (vm.isWeeklyReport) {
                return vm.haveMidsessionPrevious ? true : false;
            }
            return true; //other WeeklyReport
        }

        vm.confirmDialogRemoveMidsessions = function (message, object, $index) {
            $uibModal.open({
                templateUrl: 'app/frp-mde/confirm-dialog/confirm-dialog.html',
                controller: 'ConfirmController',
                controllerAs: 'vm',
                size: 'sm',
                windowClass: 'center-dialog-message vertical-center',
                resolve: {
                    message: function () {
                        return {'content': message};
                    }
                }
            }).result.then(function (result) {
                if (result) {
                    vm.removeColMidsessionsCallBack(object, $index);
                }
            });
        }

        vm.onClickSelectAllSubjective = function() {
            vm.subjectiveResponses.forEach(function (child) {
                child.checked = vm.checked;
            });
        }

         function updateSelectAllCheckboxSubjective() {
            var isCheckAll = true;
            vm.subjectiveResponses.forEach(function(child) {
                if(!child.checked) {
                    isCheckAll = false;
                    return;
                }
            })
            vm.checked = isCheckAll;
        }

        vm.getIdInitialScoreLR = function (sr, type) {
            // formatId:: initialScoreLeft_CES_D
            return 'initialScore' + type + '_' + sr.instrument;
        }

        vm.getIdDischargeLR = function (sr, type) {
            // formatId:: dischargeRight_{{sr.instrument}}
            return 'discharge' + type + '_' + sr.instrument;
        }

        vm.getIdMidsessionLR = function (sr, type, idx) {
            // formatId:: rowMidRight_{{sr.instrument}}_{{$index}}
            return 'rowMid' + type + '_' + sr.instrument + '_' + idx;
        }

        vm.getIdInitialScore = function (sr) {
            return 'initialScore_' + sr.instrument;
        }

        vm.getIdDischarge = function (sr) {
            return 'discharge_' + sr.instrument;
        }

        vm.getIdMidSession = function (sr, $index) {
            return 'rowMid_' + sr.instrument + '_' + $index;
        }

        $scope.$watch('vm.subjectiveImportMdeScores', function (newValue) {
            updateSelectAllCheckboxSubjective();
        });
    }

    angular.module('ipmApp').component('psychSubjectiveTestingController', {
        bindings: {
            subjectiveImportMdeScores: '=',
            subjectiveResponses: '=',
            midsessionsRemovedList: '=',
            disableFields: '<',
            reportType: '<',
            parentForm: '<',
            haveMidsessionPrevious: '<',
            onChange: '&',
            severity: '<',
            onChangeMidsessions: '&'
        },
        templateUrl: 'app/frp-mde/frp-report/psych/components/psych-subjective-testing.html',
        controller: PsychSubjectiveTestingController,
        controllerAs: 'vm'
    })
})();
